import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
let constantRouterMap = null
constantRouterMap = [
	{
		name: 'home',
		path: '/',
		redirect: '/home',
	},
	{
		name: 'home',
		path: '/home',
		component: () => import('./pages/home'),
		meta: {
			keepAlive: true,
		},
		
	},
	{
		name: 'rechange',
		path: '/rechange',
		component: () => import('./pages/rechange'),
		meta: {
			keepAlive: true,
		},
		
	},
	// {
	// 	name: 'pc_home',
	// 	path: '/pc_home',
	// 	component: () => import('./component/pc_homepage.vue'),
	// 	meta: {
	// 		keepAlive: true,
	// 	},
	// },
	// {
	// 	name: 'm_home',
	// 	path: '/m_home',
	// 	component: () => import('./component/m_homepage.vue'),
	// 	meta: {
	// 		keepAlive: true,
	// 	},
	// }
]

export default new Router({
	// mode: 'history', //后端支持可开
	// scrollBehavior: () => ({
	//     y: 0
	// }),
	routes: constantRouterMap,
})
